import { useEffect } from "react";
import { HiOutlineChevronDoubleRight } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { __APP_NAME__ } from "config/static";

export default function Container({ children, title, message, back = false }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (title) {
      document.title = `${title} | ${__APP_NAME__}`;
    }
  }, [title]);

  return (
    <div className="mx-auto mb-3 w-full max-w-6xl">
      <div className="flex flex-col">
        <div className=" rounded-[1.5rem] p-4 md:p-5">
          <div className="flex items-center gap-4 w-full">
            {back ? (
              <button
                onClick={() => navigate(-1)}
                className="portal-outline-button text-md rounded-xl px-3 py-2 md:text-xl"
              >
                <HiOutlineChevronDoubleRight />
              </button>
            ) : null}
            <h1
              className="text-md font-bold md:text-xl"
              style={{ color: "var(--layout-text)" }}
            >
              {title}
            </h1>
          </div>

          {/* {message ? (
            <h1 className="portal-message mt-4 rounded-2xl px-4 py-3 text-sm md:text-base">
              {message}
            </h1>
          ) : null} */}
        </div>

        <div className="w-full p-4">{children}</div>
      </div>
    </div>
  );
}
